import { List, Tabs, Row, Col, Slider, Modal, Icon } from 'antd';
import React from 'react';
import { connect } from 'react-redux';
import { setPropsMath } from '../../../redux/actions/appActions'
import { setEvent } from '../../../redux/actions/sportEventsActions';
import { loadKironEvents } from '../../../redux/actions/sportEventsActions';
import { SpinAndWinEnums } from '../../../helpers'
import { OddField } from '../../';


class ZoomModal extends React.Component {

    state = {
        selectedNumber: null,
        currentValue: null,
        visible: false,
    }

    findNeighbors(row, col, selectedNumber) {
        let arr = SpinAndWinEnums.boardRows;
        let neighbors = [];
        if (selectedNumber === 0) {
            neighbors = [{
                row: 4,
                col: 0,
                value: 0
            },
            {
                row: 0,
                col: 0,
                value: 3
            },
            {
                row: 1,
                col: 0,
                value: 2
            }, {
                row: 2,
                col: 0,
                value: 1
            },

            ]
        }
        else {
        

            const inBoundary = row >= 0 && row <= arr.length - 1 && col >= 0 && col <= arr[row].length - 1;
            if (!inBoundary) {
                return neighbors;
            }
            const isTop = row - 1 >= 0 && row - 1 <= arr.length - 1;
            const isLeft = col - 1 >= 0 && col - 1 <= arr[row].length - 1;
            const isRight = col + 1 >= 0 && col + 1 <= arr[row].length - 1;
            const isBottom = row + 1 >= 0 && row + 1 <= arr.length - 1;

            const isTopTwo = row - 2 >= 0 && row - 2 <= arr.length - 1;
            const isBottomTow = row + 2 >= 0 && row + 2 <= arr.length - 1;

              // Top nighbour
              if (isTopTwo) {
                neighbors.push({
                    row: row - 2,
                    col: col,
                    value: arr[row - 2][col]
                });
            }

            // Bottom nighbour
            if (isBottomTow) {
                neighbors.push({
                    row: row + 2,
                    col: col,
                    value: arr[row + 2][col]
                });
            }

            if (isTopTwo && isLeft) {
                neighbors.push({
                    row: row - 2,
                    col: col - 1,
                    value: arr[row - 2][col - 1]
                });
            }

            if (isTopTwo && isRight) {
                neighbors.push({
                    row: row - 2,
                    col: col + 1,
                    value: arr[row - 2][col + 1]
                });
            }

            if (isBottomTow && isLeft) {
                neighbors.push({
                    row: row + 2,
                    col: col - 1,
                    value: arr[row + 2][col - 1]
                });
            }

            if (isBottomTow && isRight) {
                neighbors.push({
                    row: row + 2,
                    col: col + 1,
                    value: arr[row + 2][col + 1]
                });
            }

            

            if (col === 0) {
                neighbors.push({
                    row: 4,
                    col: 0,
                    value: 0
                });
            }

            // Left nighbour
            if (isLeft) {
                neighbors.push({
                    row: row,
                    col: col - 1,
                    value: arr[row][col - 1]
                });
            }

            neighbors.push({
                row: row,
                col: col,
                value: selectedNumber
            })

            // Right nighbour
            if (isRight) {
                neighbors.push({
                    row: row,
                    col: col + 1,
                    value: arr[row][col + 1]
                });
            }

            // Top nighbour
            if (isTop) {
                neighbors.push({
                    row: row - 1,
                    col: col,
                    value: arr[row - 1][col]
                });
            }

            // Bottom nighbour
            if (isBottom) {
                neighbors.push({
                    row: row + 1,
                    col: col,
                    value: arr[row + 1][col]
                });
            }

            if (isTop && isLeft) {
                neighbors.push({
                    row: row - 1,
                    col: col - 1,
                    value: arr[row - 1][col - 1]
                });
            }

            if (isTop && isRight) {
                neighbors.push({
                    row: row - 1,
                    col: col + 1,
                    value: arr[row - 1][col + 1]
                });
            }

            if (isBottom && isLeft) {
                neighbors.push({
                    row: row + 1,
                    col: col - 1,
                    value: arr[row + 1][col - 1]
                });
            }

            if (isBottom && isRight) {
                neighbors.push({
                    row: row + 1,
                    col: col + 1,
                    value: arr[row + 1][col + 1]
                });
            }
        }

        const zoomArray = neighbors.sort((a, b) => a.value - b.value).reduce((group, curr) => {
            if (!group[curr.row]) {
                group[curr.row] = [];
            }
            group[curr.row].push(curr);
            return group;
        }, {});

        window.log("*****************************", zoomArray)
        return zoomArray;
    }

    onButtonClick(){
        this.props.hideZoomModal()
    }

    render() {
        const { row, column, selectedNumber, hideZoomModal } = this.props;
        let neighbors = this.findNeighbors(row, column, selectedNumber);

        return (

            <Modal
                className='modal-game-board'
                visible
                title={null}
                footer={null}
                closable={false}
                maskClosable={true}
                onCancel={() => {hideZoomModal() }}
            >
                {

                    neighbors && <div>
                         <div className="close-modal" onClick={() => hideZoomModal() }>
                         <Icon style={{ fontSize: 30, padding: 10}} type='close-circle'></Icon>
                         <span>CLOSE ZOOM</span>
                         </div>
                        {Object.keys(neighbors).map((row) =>

                            row != 4 &&
                            <div
                                key={row}
                                className={`rows row-${row}`}>
                                {neighbors[row].map(cell =>
                                    <div onClick={() => {this.onButtonClick() }} key={cell.value} className={`cols col-${cell.value}`}><span>{cell.value}</span> 
                                        {
                                            cell.value == selectedNumber && <OddField zoom clickable number={selectedNumber} ></OddField>
                                        }</div>)}

                            </div>
                        )}
                    </div>
                }
                {
                    neighbors && Object.keys(neighbors).map((row) =>
                        row == 4 &&
                        <div style={{ height: '100%' }}>
                            <div
                                key={row}
                                className={`rows row-${row}`}>
                                {neighbors[row].map(cell => 
                                <div onClick={() => { this.onButtonClick()  }} className={`cols col-${cell.value}`}>
                               <span style={cell.value == 0 ? {margin:"auto"}:{}}>{cell.value}</span> 
                                {
                                    cell.value == selectedNumber && <OddField zoom clickable number={selectedNumber} ></OddField>
                                }
                                </div>)}
                            </div>
                        </div>
                    )
                }

            </Modal>

        )
    }
}

const mapStateToProps = (_, initialProps) => (state) => {
    return {

    }
}

const mapDispatchToProps = (dispatch) => {
    return {

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ZoomModal);